// extracted by mini-css-extract-plugin
export default {"table":"M6PKC"};